// Change inventory status and preorder line-item property on variant change
document.addEventListener('product:variant-change', (event) => {
  const variantInventoriesScript = document.querySelector('[data-variant-inventories]');
  if (!variantInventoriesScript) return;

  let variantInventories = [];
  try {
    variantInventories = JSON.parse(variantInventoriesScript.textContent || '[]');
  } catch (error) {
    return;
  }

  const { variant } = event.detail;
  if (!variant) return;

  const variantInventory = variantInventories.find((item) => item.id === variant.id);
  if (!variantInventory) return;

  const inventoryStatusEl = document.querySelector('.ProductForm__InventoryStatus');
  if (inventoryStatusEl) {
    inventoryStatusEl.innerHTML = `${variantInventory.message}`;
  }

  const preorderWrap = document.querySelector('[data-product-form-preorder]');
  const preorderInput = document.querySelector('[data-product-form-preorder-input]');
  if (preorderWrap && preorderInput) {
    if (variantInventory.preorder) {
      preorderWrap.removeAttribute('hidden');
      preorderInput.disabled = false;
      preorderInput.value = variantInventory.preorder_message || '';
    } else {
      preorderWrap.setAttribute('hidden', '');
      preorderInput.disabled = true;
      preorderInput.value = '';
    }
  }
});